import login from './login/login_es'
import forgotPassword from './forgotPassword/forgotPassword_es'
import changePassword from './changePassword/changePassword_es'
import home from './home/home_es'
import termsAndConditions from './termsAndConditions/termsAndConditions_es'
import updatePassword from './updatePassword/updatePassword_es';
import settlements from './settlements/settlements_es';
import settlementsDO from './settlements/settlements_es_DO';
import authorizationTypes from './authorization/types/types_es';
import outpatientCare from './authorization/outpatient-care/outpatient-care_es';
import doctorFields from './authorization/outpatient-care/doctor-fields/doctor-fields_es';
import doctorFieldsDO from './authorization/outpatient-care/doctor-fields/doctor-fields_es_DO';
import identityValidation from './authorization/outpatient-care/identity-validation/identity-validation_es';
import beneficiaryResults from './authorization/outpatient-care/beneficiary-results/beneficiary-results_es';
import createSettlement from './settlements/create-settlement/create-settlement_es';
import createSettlementDO from './settlements/create-settlement/create-settlement_es_DO';
import filters from './filters/filters_es'
import settlementDetail from './settlements/settlement-detail_es'
import authorizationDetail from './authorization/detail/authorizationDetail_es';
import authorizationDetailDO from './authorization/detail/authorizationDetail_es_DO';
import prescriptionDoctorFields from './authorization/prescription/doctor-fields/doctor-fields_es';
import prescriptionDoctorFieldsDO from './authorization/prescription/doctor-fields/doctor-fields_es_DO';
import billing from './authorization/prescription/billing/billing_es';
import rcm from './rcm/home/rcmHome_es';
import rcmAccountDetail from './rcm/account-detail/account-detail_es'
import rcmChargeDetail from './rcm/charge-detail/charge-detail_es'
import supportsAdministrator from './rcm/support-administrator/support-administrator_es'
import rcmAgreements from './rcm/agreements/agreements_es'
import commentsRcm from './rcm/comments/comments_es'
import preSettlements from './rcm/pre-settlements/pre-settlements_es'
import rcmProducts from './rcm/products-configuration/ProductsConfiguration_es'
import rcmUploadAgreementMatrix from './rcm/upload-agreement-matrix/UploadAgreementMatrix_es'
import tfa from './tfa/tfa_es'
import homeV2 from './authorizationv2/homeV2_es'
import homeV2MxMutuus from './authorizationv2/homeV2_mx-mutuus_es_MX'
import sponsorTemplates from './authorizationv2/sponsor-templates/sponsorTemplates_es'
import identificationTypesMX from './authorizationv2/identificationTypes_es_MX'
import aiValidationDetail from './rcm/ai-validation-detail/ai-validation-detail_es'

const spanishMessages = {
  globalErrorUnknown: '¡Tuvimos un problema técnico! Por favor, intente de nuevo o contacte a su equipo de soporte técnico.',
  loading: 'Cargando',
  errorTitle: 'Ha ocurrido un error',
  defaultErrorDescription: 'Por favor contacte al equipo de soporte técnico para mayor información.',
  badCredentials: '¡Credenciales incorrectas! Por favor, intente de nuevo.',
  searchMatches: 'Buscar Coincidencias',
  buttons: {
    close: 'Cerrar',
    save: 'Guardar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    accept: 'Aceptar',
    add: 'Agregar',
    search: 'Buscar',
    back: 'Regresar',
  },
  errors: {
    inputValidations: {
      invalidNIT: "La información ingresada en {fieldName} no cumple con los parámetros. Por favor, verifique y corrija los datos.",
      required: 'Requerido',
      invalidFormat: 'El formato es incorrecto',
      maxLength: 'Se ha excedido el límite de {n} caracteres',
      minLength: 'Mínimo {n} caracteres',
      dynamicFieldInvalidFormat: 'El formato es incorrecto'
    },
    authorizationRequest: {
      emptyAuthorization: "La creación de la autorización falló, comuníquese con el equipo de soporte para obtener más información."
    },
    dispensingRequest: {
      emptyApprovedProducts: "No se aprobó ningún producto para esta autorización, comuníquese con el equipo de soporte para obtener más información."
    },
    voidAuthorizations: {
      success: 'Se anuló correctamente la autorización.'
    }
  },
  drawer: {
    logout: 'Cerrar sesión'
  },
  footer: {
    privacyLabel: 'Privacidad'
  },
  locales: {
    'es-DO': 'Español',
    es: 'Español',
    en: 'Inglés',
    pt: 'Portugués'
  },
  identityDocumentTypes: {
      passport: 'Pasaporte',
      nationalIdentityCard: 'Número de identificación nacional',
      socialSecurityNumber: 'Número de seguro social',
      taxIdentificationNumber: 'Número de identificación tributaria',
      electoralRegistryNumber: 'Número de identificación electoral'
  },
  genders: {
    male: 'Hombre',
    female: 'Mujer'
  },
  posology: {
      day: ' día | días',
      unit: 'unidad | unidades',
      medicalDeviceDescription: 'Usar {0} ({1}) {2} por {3} ({4}) {5}',
      half: 'medio/a',
      quarter: ' un cuarto | {value} cuartos',
      andConnector: 'y',
      pointConnector: 'punto',
  },
  sponsors: {
    umbrella: "Umbrella Osigu ARS",
    humano: 'Humano Seguros',
    universal: 'ARS Universal',
    primera: 'ARS Primera',
    senasa: 'ARS Senasa',
    humanoCategories: {
        global: "Global",
        platinum: "Platinum",
        conventional: "Convencional"
    }
  },
  voidAuthorization: {
    back: "Regresar",
    confirm: "Sí, anular",
    title: "Anular autorización",
    titleOnlyClaim: "Anular reclamo",
    hint: "Confirme para anular esta autorización. Esta acción no puede ser revertida.",
    hintOnlyClaim: "Confirme para anular este reclamo. Esta acción no puede ser revertida."
  },
  actions: {
    upload: 'Cargar',
    delete: 'Eliminar',
    replace: 'Reemplazar',
    view: 'Visualizar',
    attention: 'Atención',
    download: 'Descargar',
    edit: 'Editar'
  },
  yes: 'Si',
  no: 'No',
  supportFileUploadSuccess: 'Documento cargado exitosamente. En unos minutos estará disponible en Filezilla',
  supportFileUploadSuccessBR: 'Documento cargado exitosamente. Su analisis estará disponible en unos minutos.',
  supportFileDeleteSuccess: 'El archivo se eliminó correctamente',
  supportFileRestrictedAsAccountLevel: 'Requerido a nivel cuenta',
  emptyResults: "No se encontraron resultados",
  cancelFormButton: "Cancelar",
  chronicTreatmentLabel: 'Tratamiento crónico',
  errorLoadingFile: 'Ha ocurrido un error al cargar el archivo, por favor intente de nuevo o contacte al equipo de soporte técnico.',
  ProtectedFile: 'El documento asociado en {supports} se encuentra protegido, por favor habilitar su lectura ',
  informationSuccessfullyUpdated: 'Información actualizada correctamente',
  invalidFileType: 'Tipo de archivo inválido, tipos de archivo permitidos: PNG, JPEG, XML, PDF',
  errorEmailNotRegistered: 'El correo no se encuentra registrado, verifique e intente de nuevo.',
  login,
  forgotPassword,
  changePassword,
  home,
  termsAndConditions,
  updatePassword,
  settlements,
  authorizationTypes,
  outpatientCare,
  doctorFields,
  identityValidation,
  beneficiaryResults,
  filters,
  settlementDetail,
  createSettlement,
  authorizationDetail,
  prescriptionDoctorFields,
  billing,
  rcm,
  rcmAccountDetail,
  rcmChargeDetail,
  supportsAdministrator,
  rcmAgreements,
  commentsRcm,
  preSettlements,
  rcmProducts,
  rcmUploadAgreementMatrix,
  tfa,
  homeV2,
  sponsorTemplates,
  aiValidationDetail
}

const spanishDominicanMessages = {
  ...spanishMessages,
  ...{
    settlements: settlementsDO,
    doctorFields: doctorFieldsDO,
    authorizationDetail: authorizationDetailDO,
    prescriptionDoctorFields: prescriptionDoctorFieldsDO,
    createSettlement: createSettlementDO
  }
}

const spanishMexicanMessages = {
  'mx-mutuus': {
    'homeV2': homeV2MxMutuus,
    'home':{
      'tabs': {
        'authorizations': 'Folios',
        'NewAuthorization': 'Nuevo folio'
      },
    },
    'authorizationDetail': {
      'detailV2': {
        'authorization': 'Folio'
      }
    }
  },
  ...{
    identificationTypes: identificationTypesMX
  }
}

export { spanishMessages, spanishDominicanMessages, spanishMexicanMessages }
export default spanishMessages

